module.exports = __webpack_public_path__ + "static/media/class_job_012.c5106863.svg";